export default "__VITE_ASSET__4179c62f__"